import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import './ProfileNews.scss';
import NewsItemProfile from '../NewsItemProfile/NewsItemProfile';
import NoNews from '../Icon/NoNews';
import { useNavigate, } from 'react-router-dom';
import Skeleton from '../../containers/Library/ListingNewsSkeleton';


const ProfileNews = () => {

    const { news, loading } = useSelector(state => ({
        news: state.news.items,
        loading: state.news.loading
    }))
    const navigate = useNavigate()

    const [viewAll, setViewAll] = useState(false)

    // Sort news by recency (most recent first)
    const sortedNews = [...(news || [])].sort((a, b) => {
        const dateA = new Date(a.created_at || a.updated_at || 0);
        const dateB = new Date(b.created_at || b.updated_at || 0);
        return dateB - dateA;
    });



    // if (sortedNews.length === 0) {
    //     return <div className='pt-16 pl-16'>No news found</div>;
    // }

    return (
        <div className='mycreations-container profile-news-container'>
            <div className='creations-wrapper profile-news-wrapper'>
                {!loading && (sortedNews.length > 0) ?
                    sortedNews.slice(0, viewAll ? sortedNews.length : 6).map(news => (
                        <NewsItemProfile key={news.id} news={news} />
                    ))
                    : (loading) ?
                        [1, 2, 3, 4].map(creation => (
                            <Skeleton key={creation} width='175px' height='140px' />
                        )) :
                        <div className='profile-news-empty-state' onClick={() => navigate('/news/add')}>
                            <NoNews />
                            <p className='fg-dark fw-bold mt-24'>Write your first news</p>
                        </div>
                }
            </div>
            {!viewAll && sortedNews?.length > 6 && <div className='d-flex aic jcc w-full'>
                <button className="btn red-outline-btn btn-sm fs-tiny mt-24" onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setViewAll(true)
                }}
                >VIEW ALL</button>
            </div>}
        </div>
    )
};

export default ProfileNews; 